<template>
    <b-row class="mt-md-5 no-register">
        <b-col sm="2" v-if="icone" class="icone" :class="classeIcone">
            <i :class="`fa-lg fa ${icone}`" />
        </b-col>
        <b-col :sm="icone ? '10' : '12'">
            <slot name="title">
                <h3 v-if="titulo" :class="classeTitulo">{{ titulo }}</h3>
            </slot>
            <b-col sm="12" v-if="descricao" class="px-0">
                <div v-html="descricao" />
            </b-col>
            <slot name="botoes">
                <template v-if="botoes">
                    <b-col sm="12" class="botoes px-0 mt-4">
                        <b-button
                            v-for="(botao, index) in botoes"
                            :key="index"
                            size="md"
                            :href="botao.link"
                            :variant="botao.variant"
                            :class="`mr-2 mb-2 ${botao.class}`"
                            :target="botao.target ? botao.target : '_self'"
                        >
                            <i :class="`fa ${botao.icone}`" />
                            <span v-html="botao.texto"></span>
                        </b-button>
                        <video-tutorial v-if="exibirVideoTutorial" :url="urlVideo" />
                    </b-col>
                </template>
            </slot>

            <slot name="lista">
                <template v-if="tituloLista">
                    <h4 class="mt-4">{{ tituloLista }}</h4>
                    <p v-for="(item, index) in lista" :key="index" :class="lista.length - 1 != index ? 'mb-0' : null">
                        <i class="fa fa-check-circle text-success mr-2"></i>
                        {{ item }}
                    </p>
                </template>
            </slot>
            <!-- <p v-if="ajuda">
                <b-link v-if="$app.ocultar_tutorial == 0" :href="`${$urlBase}/ajuda/videos_tutoriais?c=${$url.controller}&a=${$url.action || 'index'}`">
                    <i class="fa fa-question-circle" />
                    Clique aqui para ver alguns tutoriais
                </b-link>
            </p> -->
        </b-col>
    </b-row>
</template>
<script>
export default {
    props: {
        icone: {
            default: null
        },
        classeIcone: {
            default: null
        },
        titulo: {
            default: null
        },
        classeTitulo: {
            default: null
        },
        descricao: {
            default: null
        },
        botoes: {
            default: null
        },
        tituloLista: {
            default: null
        },
        lista: {
            default: null
        },
        ajuda: {
            default: true
        },
        possuiVideoTutorial: {
            default: true
        },
        urlVideoTutorial: {
            default: function () {
                return {
                    module: this.$urlBase,
                    controller: this.$url.controller,
                    action: this.$url.action || 'index'
                }
            }
        }
    },
    components: {
        VideoTutorial: () => import('@/shared/components/ui/Video')
    },
    methods: {
        async mostaVideoTutorial() {
            const retorno = await this.$api.cGet(this.$urlBase + '/ajuda/video_tutorial', {
                plugin: this.urlVideoTutorial.module || '',
                controller: this.urlVideoTutorial.controller || this.$url.controller,
                action: this.urlVideoTutorial.action || this.$url.action || 'index'
            })
            if (retorno.status == 'success') {
                this.exibirVideoTutorial = this.possuiVideoTutorial
                this.urlVideo = retorno.data
            }
        }
    },
    data() {
        return {
            exibirVideoTutorial: false,
            urlVideo: null
        }
    },
    mounted() {
        if (this.ajuda) {
            this.mostaVideoTutorial()
        }
    }
}
</script>
<style lang="scss" scoped>
h3,
h4,
p {
    color: #333;
}
@media screen and (max-width: 768px) {
    .icone {
        display: none;
    }
}
</style>
